<template>
  <div class="iframe-tabs" >
    <iframe
      seamless="seamless"
      :src="getIframeSrc"
      allowfullscreen
      class="iframe-class"
      >
    </iframe>
  </div>


</template>

<script lang="ts">
import Vue from 'vue'

// Типы
interface UserData {
  access_token?: string
  [key: string]: any
}

interface AuthState {
  user: UserData | null
}

interface RootState {
  auth: AuthState
}

export default Vue.extend({
  name: 'CONFIGURATION_TABLES',

  components: {},

  props: {},

  data(): {} {
    return {}
  },

  computed: {
    getUser(): UserData | null {
      const state = this.$store.state as unknown as RootState
      return state.auth.user
    },

    getIframeSrc(): string {
      const token = this.getUser?.access_token || ''
      const baseParams = this.$localhost
        ? '&kiosk=true&route=/app/widget/spreadsheet&initApp=false'
        : '&kiosk=true&route=/app/widget/spreadsheet'
      return `/e-ui?key=${token}${baseParams}`
    },
  },

  created(): void {
    // Метод предназначен для переопределения при необходимости
  },

  methods: {},
})
</script>

<style scoped>
.iframe-tabs {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.tabs-content {
  flex: 1 0 auto;
  position: relative;
}

.tabs-content > div {
  height: 100%  !important;
}

.iframe-class {
  height: 100%  !important;
}

.v-window {
  height: 100%;
  position: relative;
}

.v-window__container {
  height: 100%  !important;
  position: relative;
}

.tab-item {
  height: 100%;
  position: relative;
  padding: 0;
}

.micro-menu {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 10;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 4px;
  padding: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.fullscreen-btn {
  background: white !important;
}

.fullscreen-btn:hover {
  background: #f5f5f5 !important;
}

</style>